import { PlusIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { Header } from '@/shared/components/ui/layout'
import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

import { CreateGlobalPcSet } from './global-pc-set/CreateGlobalPcSet'
import { useGlobalPcSets } from './GlobalPcSetsProvider'

export const GlobalPcSetsHeader = () => {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const { selectedGlobalSetIds, setSelectedGlobalSetIds } = useGlobalPcSets()
	const hasSelection = selectedGlobalSetIds.length > 0
	const handleCompareGlobalSets = () => {
		ampli.whatIfCompareClicked({
			whatif_compare_type: 'global-sets',
		})
		showModal('GLOBAL_SETS_COMPARE', {
			preselectedGlobalSetIds: selectedGlobalSetIds,
		})
		setSelectedGlobalSetIds([])
	}

	return (
		<Header className='items-center justify-between border-b px-4 py-2'>
			<h3>{t('global_sets', { defaultValue: 'Global sets' })}</h3>
			<div className='flex items-center gap-2'>
				<CreateGlobalPcSet>
					<Button size='icon'>
						<PlusIcon aria-hidden />
					</Button>
				</CreateGlobalPcSet>
				<Button
					variant='primary'
					onClick={handleCompareGlobalSets}
					disabled={!hasSelection}
				>
					{t('scenario.run_scenarios')}
					{hasSelection && <span> ({selectedGlobalSetIds.length})</span>}
				</Button>
			</div>
		</Header>
	)
}
